"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgSmile(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0c6.628 0 12 5.372 12 12s-5.372 12-12 12C5.373 24 0 18.628 0 12S5.373 0 12 0zm0 1.532C6.22 1.532 1.532 6.218 1.532 12S6.219 22.468 12 22.468c5.782 0 10.468-4.686 10.468-10.468S17.782 1.532 12 1.532zm6.454 12.839c.383.18.547.637.367 1.02-1.292 2.74-3.9 4.524-6.821 4.524-2.907 0-5.515-1.788-6.819-4.521a.766.766 0 111.383-.66c1.058 2.22 3.144 3.649 5.436 3.649 2.307 0 4.388-1.423 5.435-3.646a.766.766 0 011.02-.366zm-2.369-6.456a2.042 2.042 0 110 4.085 2.042 2.042 0 110-4.085zm-8.17 0a2.042 2.042 0 110 4.085 2.042 2.042 0 110-4.085z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgSmile;
exports.default = _default;